import React from 'react';
import SoftwareCostCalculator from '../SoftwareCostCalculator';

const SoftwareCostCalculatorEN = () => {
  return <SoftwareCostCalculator />;
};

export default SoftwareCostCalculatorEN;
